function animateValue(obj, start, end, duration, prefix = "", suffix = "") {
	let startTimestamp = null;

	const step = (timestamp) => {
		if (!startTimestamp) startTimestamp = timestamp;
		const progress = Math.min((timestamp - startTimestamp) / duration, 1);
		const currentValue = Math.floor(progress * (end - start) + start);
		obj.innerHTML = `${prefix}${currentValue.toLocaleString()}${suffix}`;

		if (progress < 1) {
			window.requestAnimationFrame(step);
		}
	};

	window.requestAnimationFrame(step);
}

document.addEventListener("DOMContentLoaded", () => {
	const elements = document.querySelectorAll(".stat-title");
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const element = entry.target;
				const rawValue = element.textContent.trim();
				const prefixMatch = rawValue.match(/^\D+/);
				const suffixMatch = rawValue.match(/\D+$/);
				const prefix = prefixMatch ? prefixMatch[0] : "";
				const suffix = suffixMatch ? suffixMatch[0] : "";
				// const cleanValue = rawValue.replace(/^\D+|\D+$/g, "");
				const cleanValue = rawValue.replace(/[^\d]/g, "");
				const startValue = parseInt(cleanValue, 10);

				const steps = Math.abs(startValue);
				const durationPerStep = 10;
				const minDuration = 750;
				const maxDuration = 2000;
				const duration = Math.max(
					minDuration,
					Math.min(steps * durationPerStep, maxDuration),
				);

				if (!isNaN(startValue)) {
					animateValue(element, 0, startValue, duration, prefix, suffix);
				}

				observer.unobserve(element);
			}
		});
	});

	elements.forEach((element) => observer.observe(element));
});
